import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BcacCardComponent } from './bcac-card.component';
import { NzGridModule } from 'ng-zorro-antd/grid';



@NgModule({
  declarations: [BcacCardComponent],
  imports: [
    CommonModule,
    NzGridModule
  ],
  exports: [
    BcacCardComponent
  ]
})
export class BcacCardModule { }
